import React from 'react';
import Grid2 from '@mui/material/Grid2';
import TableSearch from './TableSearch';
import EmailComposerDialog from './EmailComposerDialog';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';
import { Typography, CircularProgress } from '@mui/material';
import { BatchActionIconButton, PrimaryActionButtonForTable } from './TableStyles';
import RecordCountBox from '../../../Components/RecordCountBox'
import { DownloadFileIcon, ExtraSettingsIcon } from '../Icons';
import { useTranslation } from 'react-i18next';
import { PrimaryTooltip } from '../../../Components/StyledComponent';


const TableHeaderAndActions = ({

    title,
    count,
    onPrimaryButtonClick,
    showPrimaryButton = true,
    primaryButtonLabel,
    onSearchApply,
    searchableFields,
    disableSearch,
    searchSuggestionsHandler,
    onSendEmail,
    disableDownloads = false,
    showEmailComposer = true,
    selectedRows = [],
    totalRowSelectionCount = 0,
    getCSVData = () => { },
    onDownloadCSV = () => { },
    customRightActions = false,
    customRightActionsView = null,
    availableEmailDomains = [],
    emailInfo = {},
    isDownloading = false,
    alwaysEnableActions = false
}) => {

    let isBatchActionButtonActive = alwaysEnableActions || totalRowSelectionCount > 0
    const { t } = useTranslation(['common', 'generic_table'])

    return (
        <Grid2 container alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>

            <Grid2 container direction="row" alignItems="center" spacing={2} sx={{ minHeight: '35px' }}>
                <Typography variant="fw500s16lh24c000000"> {title}</Typography>
                {count != undefined && <RecordCountBox count={count} />}

                {
                    showPrimaryButton && <PrimaryActionButtonForTable variant="outlined" color="primary" onClick={onPrimaryButtonClick} >
                        {primaryButtonLabel}
                    </PrimaryActionButtonForTable>
                }
            </Grid2>

            {(
                <Grid2
                    container
                    direction="row"
                    alignItems="center"
                    spacing={1}
                    justifyContent="flex-end"
                    sx={{ flexGrow: 1, flexWrap: 'nowrap' }}>
                    {
                        !disableSearch && <TableSearch onSearch={onSearchApply} searchableFields={searchableFields} searchSuggestionsHandler={searchSuggestionsHandler} />
                    }

                    {
                        totalRowSelectionCount > 0 && <Typography data-testid="table-selected-count" variant="fw600s14lh16c6D72F6">{totalRowSelectionCount} {t('generic_table:row_selected')} </Typography>
                    }

                    {!disableDownloads && (
                        <PrimaryTooltip
                            title={
                                isDownloading
                                    ? <>Downloading...</>
                                    : isBatchActionButtonActive
                                        ? <>Download Data</>
                                        : <>Download Data <br /> (Select minimum 1 row)</>
                            }
                            placement="bottom"
                        >
                            <BatchActionIconButton
                                data-testid="download-csv-btn"
                                onClick={onDownloadCSV}
                                active={isBatchActionButtonActive && !isDownloading}
                                disabled={!isBatchActionButtonActive || isDownloading}
                            >
                                {isDownloading ? (
                                    <CircularProgress size={16} color="inherit" />
                                ) : (
                                    <DownloadFileIcon fontSize="inherit" />
                                )}
                            </BatchActionIconButton>
                        </PrimaryTooltip>
                    )}

                    {!disableDownloads && showEmailComposer && (
                        <EmailComposerDialog
                            triggerTestId="email-data-btn"
                            availableEmailDomains={availableEmailDomains}
                            emailInfo={emailInfo}
                            getCSVData={getCSVData}
                            onDownloadCSV={onDownloadCSV}
                            selectedRows={selectedRows}
                            active={isBatchActionButtonActive}
                            onSendEmail={onSendEmail}
                        />
                    )}

                    {false && <BatchActionIconButton onClick={() => { }} active={false} disabled={true}>
                        <ExtraSettingsIcon />
                    </BatchActionIconButton>}
                </Grid2>
            )}

            {customRightActions && customRightActionsView}

        </Grid2>
    );
};

export default TableHeaderAndActions;
